import { useEffect } from 'react';
import { useList, ListActions } from '@zmedia/bm-soccer-ui/hooks';
import { IListState } from '@zmedia/bm-soccer-ui/hooks/useList/store';
import { useInView, IntersectionOptions } from 'react-intersection-observer';
import { TOTAL_PAGINATION } from '@zmedia/bm-soccer-ui/constants';

const DEFAULT_OPTIONS: IntersectionOptions = {
    threshold: 0,
    rootMargin: '50px',
};

export function useIntersectionLoader<T>(
    fetchFn: (...params: any) => any,
    initState?: object,
    intersectionOptions: IntersectionOptions = {},
    startPage: number = 0,
    limitLoadmore: boolean = true
): [any, IListState<T>, ListActions] {
    const [list, listActions] = useList<T>({ fetchFn, initState });
    const options = Object.assign(DEFAULT_OPTIONS, intersectionOptions);
    const [loaderRef, inView] = useInView(options);

    useEffect(() => {
        if (list.hasMore && inView && !list.isFetching) {
            if (
                !limitLoadmore ||
                startPage + TOTAL_PAGINATION > list.currentPage
            ) {
                listActions.onPageChange(list.currentPage + 1);
            }
        }
    }, [inView, startPage]);

    return [loaderRef, list, listActions];
}
